import { NgModule } from '@angular/core';
import { ModalComponent } from './modal.component';
import { ModalOverlayComponent } from './modal-overlay.component';
import {
	FormFooterContentDirective,
	ModalFormComponent
} from './modal-form.component';
import { EdAssistUIHeadingModule } from '../heading';
import { CommonModule } from '@angular/common';
import { MODAL_SIZES } from './modal-sizes.enum';
import { ReactiveFormsModule } from '@angular/forms';
import { EdAssistUIButtonModule } from '@edassist-ui/button';
import { EdAssistUIIconModule } from '@edassist-ui/icon';
import { AutoFocusDirective } from '../auto-focus/auto-focus.directive';

const COMPONENTS = [
	ModalComponent,
	ModalOverlayComponent,
	ModalFormComponent,
	AutoFocusDirective,
	FormFooterContentDirective
];

@NgModule({
	imports: [
		EdAssistUIIconModule,
		CommonModule,
		EdAssistUIHeadingModule,
		ReactiveFormsModule,
		EdAssistUIButtonModule
	],
	exports: COMPONENTS,
	declarations: COMPONENTS
})
class EdAssistUIModalModule {}

export {
	EdAssistUIModalModule,
	ModalComponent,
	ModalOverlayComponent,
	MODAL_SIZES
};
